(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eme-contact-page"]) return;
  try {
    
function emeFillProjectContext() {
  const params = new URLSearchParams(window.location.search);
  const allowed = { project_type: 'project_type', design: 'design_direction', city_state: 'city_state', quantity: 'quantity', target_date: 'target_date', budget: 'budget' };
  document.querySelectorAll('.eme-contact__inquiry form').forEach((form) => {
    Object.entries(allowed).forEach(([parameter, field]) => {
      const value = params.get(parameter);
      const input = form.querySelector('[name="contact[' + field + ']"]');
      if (input && !input.value && value) input.value = value.slice(0, 250);
    });
    const source = params.get('source');
    const sourceInput = form.querySelector('[data-eme-request-source]');
    if (sourceInput && source && /^[a-z0-9_-]{1,80}$/i.test(source)) sourceInput.value = source;
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', emeFillProjectContext);
else emeFillProjectContext();
document.addEventListener('shopify:section:load', emeFillProjectContext);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eme-grand-opening-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('eme-grand-opening-popup')) {
    customElements.define('eme-grand-opening-popup', class extends HTMLElement {
      static shouldShow(data, now, dismissed, editor) {
        if (data.enabled !== 'true') return false;
        if (editor) return true;
        const start = Date.parse(data.start);
        const end = Date.parse(data.end);
        if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start || now < start || now >= end) return false;
        const hours = Math.max(0, Number(data.hours) || 0);
        return !dismissed || !Number.isFinite(Number(dismissed)) || now - Number(dismissed) >= hours * 3600000;
      }
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.editor = this.dataset.editor === 'true';
        this.key = 'eme-promo-' + this.dataset.campaign + '-' + this.dataset.end;
        this.onCancel = event => { event.preventDefault(); this.dismiss(); };
        this.onBackdrop = event => { if (event.target === this.dialog) { const r = this.dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dismiss(); } };
        this.onSectionSelect = event => { if (event.detail.sectionId === this.dataset.sectionId) this.show(); };
        this.dialog.querySelector('button').addEventListener('click', () => this.dismiss());
        this.dialog.addEventListener('cancel', this.onCancel);
        this.dialog.addEventListener('click', this.onBackdrop);
        this.dialog.querySelectorAll('a').forEach(a => a.addEventListener('click', () => this.dismiss()));
        document.body.append(this.dialog);
        document.addEventListener('shopify:section:select', this.onSectionSelect);
        this.openTimer = setTimeout(() => this.show(), this.editor ? 150 : Math.max(0, Number(this.dataset.delay) || 0) * 1000);
        this.scheduleExpiry();
      }
      remembered() {
        try { return localStorage.getItem(this.key); } catch { try { return sessionStorage.getItem(this.key); } catch { return null; } }
      }
      show() {
        if (!this.isConnected || !this.dialog || this.dialog.open) return;
        if (!this.constructor.shouldShow(this.dataset, Date.now(), this.remembered(), this.editor)) return;
        if (document.querySelector('dialog[open]')) return;
        this.dialog.showModal();
      }
      dismiss() {
        clearTimeout(this.openTimer);
        if (!this.editor) {
          try { localStorage.setItem(this.key, String(Date.now())); } catch { try { sessionStorage.setItem(this.key, String(Date.now())); } catch {} }
        }
        if (this.dialog.open) this.dialog.close();
      }
      scheduleExpiry() {
        if (this.editor) return;
        const remaining = Date.parse(this.dataset.end) - Date.now();
        if (!Number.isFinite(remaining) || remaining <= 0) { if (this.dialog.open) this.dialog.close(); clearTimeout(this.openTimer); return; }
        this.expiryTimer = setTimeout(() => this.scheduleExpiry(), Math.min(remaining, 2147480000));
      }
      disconnectedCallback() {
        clearTimeout(this.openTimer);
        clearTimeout(this.expiryTimer);
        document.removeEventListener('shopify:section:select', this.onSectionSelect);
        this.dialog?.remove();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eme-hero-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('eme-hero-carousel')) {
  class EmeHeroCarousel extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.slides = Array.from(this.querySelectorAll('[data-eme-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
      this.status = this.querySelector('[data-carousel-status]');
      this.controls = this.querySelector('.eme-hero-carousel__controls');
      this.index = 0;
      this.paused = Boolean(window.Shopify?.designMode);
      this.hovered = false;
      this.focused = false;
      this.timer = null;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.interval = Math.max(4000, Number(this.dataset.interval) || 8000);
      const listen = (target, type, callback, options = {}) => target?.addEventListener(type, callback, { ...options, signal });
      this.dots.forEach(dot => listen(dot, 'click', () => this.show(Number(dot.dataset.carouselDot))));
      listen(this, 'pointerenter', event => { if (event.pointerType !== 'touch') { this.hovered = true; this.stop(); } });
      listen(this, 'pointerleave', () => { this.hovered = false; this.schedule(); });
      listen(this, 'focusin', () => { this.focused = true; this.stop(); });
      listen(this, 'focusout', () => { setTimeout(() => { this.focused = this.contains(document.activeElement); this.schedule(); }, 0); });
      listen(this, 'keydown', event => {
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      listen(this, 'pointerdown', event => {
        if (event.pointerType === 'touch' && !event.target.closest('button')) this.touch = { x: event.clientX, y: event.clientY };
      });
      listen(this, 'pointerup', event => {
        if (!this.touch) return;
        const dx = event.clientX - this.touch.x, dy = event.clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          this.suppressClick = true;
          this.show(this.index + (dx < 0 ? 1 : -1));
          setTimeout(() => { this.suppressClick = false; }, 400);
        }
      });
      listen(this, 'pointercancel', () => { this.touch = null; });
      listen(this, 'click', event => {
        if (!this.suppressClick) return;
        if (event.target.closest('.eme-hero-carousel__image-link')) { event.preventDefault(); event.stopPropagation(); }
        this.suppressClick = false;
      }, { capture: true });
      listen(document, 'visibilitychange', () => this.schedule());
      listen(this.motion, 'change', () => {  this.schedule(); });
      listen(document, 'shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
        if (index >= 0) { this.paused = true; this.show(index);  }
      });
      this.show(0, false);
      
      const firstImage = this.slides[0]?.querySelector('img');
      if (firstImage && !firstImage.complete) listen(firstImage, 'load', () => this.schedule(), { once: true });
      else this.schedule();
    }
    disconnectedCallback() { this.stop(); this.abort?.abort(); this.abort = null; }
    stop() { if (this.timer) clearTimeout(this.timer); this.timer = null; }
    schedule() {
      this.stop();
      if (this.slides?.length < 2 || this.dataset.autoplay !== 'true' || this.paused || this.hovered || this.focused || this.motion.matches || document.hidden) return;
      this.timer = setTimeout(() => this.show(this.index + 1, false), this.interval);
    }
    show(index, manual = true) {
      if (!this.slides.length) return;
      const focusedControl = this.controls?.contains(document.activeElement) ? document.activeElement : null;
      this.index = (index + this.slides.length) % this.slides.length;
      this.dataset.activeIndex = String(this.index);
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; slide.setAttribute('aria-hidden', String(i !== this.index)); });
      if (this.controls) {
        const content = this.slides[this.index].querySelector('.eme-custom-hero__content');
        if (content && this.controls.parentElement !== this.slides[this.index]) content.before(this.controls);
        focusedControl?.focus({ preventScroll: true });
      }
      this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === this.index)));
      if (this.status && manual) { this.status.setAttribute('aria-live', 'polite'); this.status.textContent = this.slides[this.index].getAttribute('aria-label'); }
      const next = this.slides[(this.index + 1) % this.slides.length]?.querySelector('img');
      if (next) next.loading = 'eager';
      this.schedule();
    }
  }
  customElements.define('eme-hero-carousel', EmeHeroCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eme-service-marquee"] && !Shopify.designMode) return;
  try {
    
 if(!customElements.get('eme-service-marquee')){
  customElements.define('eme-service-marquee',class extends HTMLElement{
   connectedCallback(){
    this.abort?.abort();this.abort=new AbortController();
    const button=this.querySelector('button');
    button.addEventListener('click',()=>{
     const paused=this.dataset.paused!=='true';this.dataset.paused=String(paused);
     button.setAttribute('aria-pressed',String(paused));button.setAttribute('aria-label',paused?button.dataset.resumeLabel:button.dataset.pauseLabel);
     button.firstElementChild.textContent=paused?'▷':'Ⅱ';
    },{signal:this.abort.signal});
   }
   disconnectedCallback(){this.abort?.abort();}
  });
 }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eme-service-story"] && !Shopify.designMode) return;
  try {
    
 if(!customElements.get('eme-service-story')){
  customElements.define('eme-service-story',class extends HTMLElement{
   connectedCallback(){
    this.abort?.abort();this.abort=new AbortController();this.panels=[...this.querySelectorAll('[data-service-panel]')];this.buttons=[...this.querySelectorAll('[data-service-toggle]')];
    this.buttons.forEach((button,index)=>{
     button.addEventListener('click',()=>this.select(index),{signal:this.abort.signal});
     button.addEventListener('focus',()=>this.select(index),{signal:this.abort.signal});
     button.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse')this.select(index)},{signal:this.abort.signal});
     button.addEventListener('keydown',event=>{
      let next=index;
      if(event.key==='ArrowRight'||event.key==='ArrowDown')next=(index+1)%this.buttons.length;
      else if(event.key==='ArrowLeft'||event.key==='ArrowUp')next=(index-1+this.buttons.length)%this.buttons.length;
      else if(event.key==='Home')next=0;
      else if(event.key==='End')next=this.buttons.length-1;
      else return;
      event.preventDefault();this.buttons[next].focus();
     },{signal:this.abort.signal});
    });
    document.addEventListener('shopify:block:select',event=>{const index=this.panels.indexOf(event.target.closest('[data-service-panel]'));if(index>=0)this.select(index)},{signal:this.abort.signal});
   }
   select(index){this.panels.forEach((panel,i)=>{const active=i===index;panel.dataset.active=String(active);panel.querySelector('[data-service-toggle]').setAttribute('aria-expanded',String(active));panel.querySelector('.eme-service-story__content').hidden=!active})}
   disconnectedCallback(){this.abort?.abort();}
  });
 }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eme-welcome-offer"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('eme-welcome-offer')){
    customElements.define('eme-welcome-offer',class extends HTMLElement{
      connectedCallback(){
        if(this.ready)return;this.ready=true;
        this.card=this.querySelector('aside');this.launcher=this.querySelector('.eme-welcome-offer__launcher');
        if(!this.card||!this.launcher)return;
        this.key='eme-welcome5-dismissed-v1';
        this.querySelector('.eme-welcome-offer__close').addEventListener('click',()=>this.dismiss());
        this.launcher.addEventListener('click',()=>this.open());
        this.addEventListener('keydown',e=>{if(e.key==='Escape'&&!this.card.hidden){this.dismiss();this.launcher.focus();}});
        let dismissed=0;try{dismissed=Number(localStorage.getItem(this.key))||0;}catch{}
        const elapsed=Date.now()-dismissed,period=Math.max(1,Number(this.dataset.days)||7)*86400000;
        if(this.dataset.editor==='true')this.open();
        else if(dismissed&&elapsed<period)this.launcher.hidden=false;
        else this.timer=setTimeout(()=>{if(document.querySelector('dialog[open]')){this.launcher.hidden=false;return;}this.open();},Math.max(0,Number(this.dataset.delay)||5)*1000);
      }
      open(){this.card.hidden=false;this.launcher.hidden=true;this.launcher.setAttribute('aria-expanded','true');}
      dismiss(){clearTimeout(this.timer);this.card.hidden=true;this.launcher.hidden=false;this.launcher.setAttribute('aria-expanded','false');try{localStorage.setItem(this.key,String(Date.now()));}catch{}}
      disconnectedCallback(){clearTimeout(this.timer);this.ready=false;}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
